module.exports = __webpack_public_path__ + "static/9-1e5d23a587a713298bd7a04f6ed29e97.jpg";